<template>
  <div class="table-wrapper">
    <ul class="table-header">
      <li 
        v-for="(head, index) in columns" 
        :key="index" 
        :style="{textAlign: head.align || 'left', width: `${100 / columns.length}%`}"
        class="header-item"
        @click="sortHandler(index, head.isSort)"
      >
        <span>{{ head.lable }}</span>
        <img :src="sortStatus[index]" alt="" class="sort-icon" v-if="head.isSort">
      </li>
    </ul>
    <template v-if="isRefresh">
      <ul class="table-body" :style="{height: `${bodyHeight}vh`}">
        <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
            <van-list
              v-model="listLoading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
                <li v-for="(item, index) in tableData" :key="index" class="row-class" >
                    <div 
                      v-for="h in columns" 
                      :key="h['prop']" 
                      class="body-item" 
                      :style="{ textAlign: h['align']  || 'left', width: `${100 / columns.length}%`}"
                    >
                      {{ item[h['prop']] }}
                    </div>
                </li>
            </van-list>
        </van-pull-refresh>
      </ul>
    </template>
    <template v-else>
      <ul class="table-body" :style="{height: `${bodyHeight}vh`}">
        <li v-for="(item, index) in tableData" :key="index" class="row-class" >
            <div 
              v-for="(h, p, i) in item" 
              :key="p" 
              class="body-item" 
              :style="{ textAlign: columns[i].align || 'left', width: `${100 / columns.length}%`}"
            >
              {{ item[columns[i].prop] }}
            </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import Descending from "@/assets/descending.png"
import Ascending from "@/assets/ascending.png"
import NoSort from "@/assets/noSort.png"
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isRefresh: {
      type: Boolean,
      default: false
    },
    isListloading: {
      type: Boolean,
      default: false
    },
    isRefreshLoading: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    },
    bodyHeight: {
      type: [String, Number],
      default: 72
    },
    activeSort: {
      type: Array,
      default: () => [0, false]
    }
  },
  data () {
    return {
      refreshLoading: this.isRefreshLoading,
      listLoading: this.isListloading,
      sortStatus: this.columns.map(col => NoSort),
      curSort: []
    }
  },
  created () {
    if (this.activeSort.length) {
      let index = this.activeSort[0]
      let status = this.activeSort[1]
      this.$set(this.sortStatus, index, status ? Descending : Ascending)
    }
  },
  methods: {
    onLoad () {
      this.$emit('onLoadHandler')
    },
    onRefresh () {
      this.$emit('onRefreshHandler')
    },
    sortHandler (index, isSort) {
      if (!isSort) {
        return 
      }
      let curStatus = this.sortStatus[index]
      let status
      if (curStatus === Descending) {
        this.$set(this.sortStatus, index, Ascending)
        status = Ascending
      } else if (curStatus === Ascending) {
        this.$set(this.sortStatus, index, Descending)
        status = Descending
      } else if (curStatus === NoSort) {
         this.sortStatus.forEach((item, i) => {
          this.$set(this.sortStatus, i, NoSort)
         })
         this.$set(this.sortStatus, index, Descending)
         status = Descending
      }
      this.$emit("sortFun", index, status === Ascending )
    }
  },
  watch: {
    refreshLoading (status) {
      this.$emit('update:isRefreshLoading', status)
    },
    isRefreshLoading (status) {
      this.refreshLoading = status
    },
    listLoading (status) {
      this.$emit('update:isListloading', status)
    },
    isListloading (status) {
      this.listLoading = status
    },
    activeSort (sort) {
      this.$set(this.sortStatus, sort[0], sort[1])
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  background-color: #fff;
}
.table-header {
  display: flex;
  margin: 0;
}

.header-item {
  /* display: flex;
  align-items: center;
  justify-content: center; */
  font-weight:700;
  color:#333333;
  font-size:14px;
  padding: 18px 0;
  box-shadow:0px -1px 0px rgba(0, 0, 0, 0.06) inset;
}
.body-list {
  display: flex;
}

.body-item {
  padding: 18px 0;
  box-shadow:0px -1px 0px rgba(0, 0, 0, 0.06) inset;
}

.row-class {
  display: flex;
}

.table-body {
  padding-bottom: 5px;
  overflow-y: scroll;
}

.icon-paixu {
  font-size: 12px;
  margin-left: 2px;
}
.sort-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
</style>